import { trimEnd } from 'lodash';

import { isBrowser } from './runtime';

export const siteBaseURL = import.meta.env.BASE_URL;

export const TRIMMED_BASE_URL = trimEnd(siteBaseURL, '/');

export const FULL_BASE_URL = isBrowser() ? location.origin + siteBaseURL : '';

export function concatPath(path: string) {
  return `${TRIMMED_BASE_URL}${path}`;
}

export function isExternalUrl(url: string) {
  const path = url.replace(FULL_BASE_URL, '/');

  const isExternal = path && /^([\w]+:\/\/|mailto:|file:|tel:)/.test(path);

  return {
    isExternal,
    path,
  };
}
